export const SearchbarTestIds = {
  buttonSearchCollapsed: 'button_search_collapsed',
  buttonSearch: 'button_search'
} as const;
